import { render, staticRenderFns } from "./si_Logo.vue?vue&type=template&id=b80c32da&scoped=true&"
import script from "./si_Logo.vue?vue&type=script&lang=js&"
export * from "./si_Logo.vue?vue&type=script&lang=js&"
import style0 from "./si_Logo.vue?vue&type=style&index=0&id=b80c32da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80c32da",
  null
  
)

export default component.exports